/**
 * @author rmh
 * 模块说明：版别关联供应商
 */
import { Service } from '@/tools'

export class noticeService<T extends TProcure.Notice> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TProcure.Notice}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 模块说明：列表相关接口
   *   /api/procure/supplier/receipt/notice/v1/page
   */
  noticePage = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiPage', data)
  }

   /**
   * 模块说明：收货单详情查询
   *  /api/procure/supplier/receipt/notice/v1/receiptNoticeDetail
   */
   receiptNoticeDetail = <K extends T['ApiReceiptNoticeDetail']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiReceiptNoticeDetail', data)
  }

   /**
   * 模块说明：收货单商品详情查询
   *   /api/procure/supplier/receipt/notice/v1/receiptNoticeCommodityDetail

   */
   receiptNoticeCommodityDetail = <K extends T['ApiReceiptNoticeCommodityDetail']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiReceiptNoticeCommodityDetail', data)
  }
}
